/**
 * 保存音频
 */
import { DataValidator, IsNumber, IsString, Required, transformKeys } from '@/utils/type-vaildator';
import api from './api';

/** 音频生成状态响应参数 */
export interface SaveAudioInfoResponse {
  created_at: string;
  description: string;
  id: string;
  input_text: string;
  name: string;
  process_status: number;
  provider: string;
  sample_url: string;
  task_id: string;
  updated_at: string;
  user_id: string;
  voice_tts_id: string;
}

/** 前端需要的数据 */
export class SavedAudioData {
  @Required("createdAt cannot be empty")
  @IsString("createdAt must be a string")
  createdAt: string;

  @Required("id cannot be empty")
  @IsString("id must be a string")
  id: string;

  @Required("name cannot be empty")
  @IsString("name must be a string")
  name: string;

  @Required("processStatus cannot be empty")
  @IsNumber("processStatus must be a number")
  processStatus: number;

  @Required("sampleUrl cannot be empty")
  @IsString("sampleUrl must be a string")
  sampleUrl: string;

  @Required("provider cannot be empty")
  @IsString("provider must be a string")
  provider: string;

  @Required("taskId cannot be empty")
  @IsString("taskId must be a string")
  taskId: string;

  @Required("voiceTtsId cannot be empty")
  @IsString("voiceTtsId must be a string")
  voiceTtsId: string;
}

const transformAndValidatePollAudioStatusData = (
  response: SaveAudioInfoResponse
): SavedAudioData => {
  const transformedData = transformKeys(response);

  try {
    const mainData = DataValidator.validateOrThrow(
      transformedData,
      SavedAudioData
    );
    return mainData;
  } catch (error) {
    console.error("Audio data validation failed:", error.message);
    throw error;
  }
};

/**
 * 保存音频
 * @param taskId 
 * @returns 
 */
export const saveAudioInfo = async (taskId: string) => {
  const response = await api.get<SaveAudioInfoResponse>(`/audio/save-info/${taskId}`);
  return transformAndValidatePollAudioStatusData(response.data);
}